export const PRODUCT_COLOR_NEP = 'NEP';
export const PRODUCT_COLOR_NVI = 'NVI';
